import { Button, Flex, Typography, theme } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import React from 'react';

const { Text } = Typography;

type IntegrationPathOptionProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
  tag?: React.ReactNode;
  recommended?: boolean;
  onClick: () => void;
};

const IntegrationPathOption = ({
  icon,
  title,
  description,
  tag,
  recommended = false,
  onClick,
}: IntegrationPathOptionProps) => {
  const { token } = theme.useToken();

  const optionStyle: React.CSSProperties = {
    height: 'auto',
    padding: token.padding,
    borderRadius: token.borderRadiusLG,
    textAlign: 'left',
    whiteSpace: 'normal',
    ...(recommended && { backgroundColor: token.colorPrimaryBg, borderColor: token.colorPrimary }),
  };

  const iconBadgeStyle: React.CSSProperties = {
    width: token.controlHeightLG,
    height: token.controlHeightLG,
    flexShrink: 0,
    // FIXME: no exact token — a circle, not a themed radius.
    borderRadius: '50%',
    border: `${token.lineWidth}px ${token.lineType} ${token.colorBorderSecondary}`,
    backgroundColor: token.colorBgContainer,
  };

  return (
    <Button block style={optionStyle} onClick={onClick}>
      <Flex justify="space-between" align="center" gap={token.marginSM} style={{ width: '100%' }}>
        <Flex align="center" gap={token.marginSM}>
          <Flex align="center" justify="center" style={iconBadgeStyle} aria-hidden="true">
            {icon}
          </Flex>
          <Flex vertical align="flex-start">
            <Flex align="center" gap={token.marginXS}>
              <Text strong>{title}</Text>
              {tag}
            </Flex>
            <Text type="secondary">{description}</Text>
          </Flex>
        </Flex>
        <ArrowRightOutlined style={{ color: token.colorPrimary }} />
      </Flex>
    </Button>
  );
};

export default IntegrationPathOption;
